import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const telNumber = t('public.contact.tel');
  const mobileNumber = t('public.contact.mobile');
  const telHref = `tel:${String(telNumber).replace(/[^+\d]/g, '')}`;
  const mobileHref = `tel:${String(mobileNumber).replace(/[^+\d]/g, '')}`;

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.section}>
          <h3 style={styles.heading}>NLBA</h3>
          <p style={styles.text}>{t('public.footer.tagline')}</p>
        </div>
        
        <div style={styles.section}>
          <h4 style={styles.subHeading}>Pagina's</h4>
          <ul style={styles.list}>
            <li><Link to="/" style={styles.link}>{t('nav.home')}</Link></li>
            <li><Link to="/over-nlba" style={styles.link}>Over NLBA</Link></li>
            <li><Link to="/brochures/hbo" style={styles.link}>Opleidingen</Link></li>
            <li><Link to="/news" style={styles.link}>{t('nav.news')}</Link></li>
            <li><Link to="/contact" style={styles.link}>Contact</Link></li>
          </ul>
        </div>

        <div style={styles.section}>
          <h4 style={styles.subHeading}>{t('public.contact.title')}</h4>
          <ul style={styles.list}>
            <li style={styles.text}>{t('public.contact.emailLabel')}: {t('public.contact.email')}</li>
            <li style={styles.text}>
              {t('public.contact.telLabel')}: <a href={telHref} style={styles.linkInline}>{telNumber}</a>
            </li>
            <li style={styles.text}>
              {t('public.contact.mobileLabel')}: <a href={mobileHref} style={styles.linkInline}>{mobileNumber}</a>
            </li>
            <li style={styles.text}>{t('public.contact.location')}</li>
          </ul>
        </div>
      </div>

      <div style={styles.bottom}>
        <p style={styles.copyright}>© {new Date().getFullYear()} NLBA. {t('public.footer.rights')}</p>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    backgroundColor: '#333',
    color: '#ffffff',
    padding: '3rem 0 1rem',
    marginTop: 'auto'
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 2rem',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '2rem'
  },
  section: {
    display: 'flex',
    flexDirection: 'column'
  },
  heading: {
    color: '#ffffff',
    marginBottom: '1rem',
    fontSize: '1.5rem'
  },
  subHeading: {
    color: '#ffffff',
    marginBottom: '1rem',
    fontSize: '1.1rem'
  },
  text: {
    color: 'rgba(255,255,255,0.8)',
    marginBottom: '0.5rem'
  },
  list: {
    listStyle: 'none',
    padding: 0,
    margin: 0
  },
  link: {
    color: 'rgba(255,255,255,0.8)',
    textDecoration: 'none',
    display: 'block',
    marginBottom: '0.5rem',
    transition: 'color 0.2s'
  },
  linkInline: {
    color: '#f8b84a',
    textDecoration: 'none',
    fontWeight: 700
  },
  bottom: {
    borderTop: '1px solid rgba(255,255,255,0.1)',
    marginTop: '2rem',
    paddingTop: '1rem',
    textAlign: 'center'
  },
  copyright: {
    color: 'rgba(255,255,255,0.6)',
    fontSize: '0.875rem'
  }
};

export default Footer;
